export default "__VITE_ASSET__BWMp243t__"